import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import axios from 'axios';
// import numeral from 'numeral';
import Rodal from 'rodal';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'rodal/lib/rodal.css';

import Conf from 'utils/Conf';
import MediaLibraryVideoPlayer from 'components/VideoPlayer/MediaLibraryVideoPlayer';
// import Context from 'utils/Context';

const MediaLibraryModal = ({media, onClose}) => {
  const {t} = useTranslation();
  // const {appState} = useContext(Context);

  const [hasCookie, setHasCookie] = useState(false);

  useEffect(() => {
    if (!media) return;
    axios
      .get(
        `${Conf.apiBaseUriLegacy}/get_media_auth_cookies/${media?.film_id ? 'mediatheque_film/' : 'mediatheque_cinema/'}${
          media?.id
        }`,
        {
          withCredentials: true,
        },
      )
      .then(res => {
        setHasCookie(true);
      });

    return () => {
      setHasCookie(false);
    };
  }, [media]);

  if (!media || !hasCookie) return null;

  return (
    <Rodal visible={true} onClose={onClose} playing={true}>
      <div className="mediaPopupContainer">
        <MediaLibraryVideoPlayer
          url={media.media_video_url}
          // width={500}
          // height={375}
        />
        <div className="topBar">
          <div className="title">{media.title}</div>
          <div className="right">
            <div className="duration">{t('duree-min', {duration: media.duration})}</div>
            {/* <div className="price">{`${numeral(media.price / 100).format('0.00')} ${
              appState.conf.CURRENCY_SYMBOL
            }`}</div> */}
          </div>
        </div>
        <div className="description">{media.description}</div>
      </div>
    </Rodal>
  );
};

export default MediaLibraryModal;
